// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__yV5Gm","section":"Sidebar_section__F5kJB","subsection":"Sidebar_subsection__Y4TOt","topicButton":"Sidebar_topicButton__GXLrk"};